import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { useEffect, useMemo } from "react";

import { createQueryClient } from "./lib/query.ts";

import { QueryDevtools } from "./app/QueryDevtools.tsx";
import { router } from "./app/router.tsx";
import { liveSession, SessionProvider } from "./app/session.tsx";
import { applyTheme, readTheme } from "./app/theme.ts";

export function App() {
  // Uno solo para toda la vida de la aplicación: recrearlo en cada render
  // tiraría la caché entera.
  const queryClient = useMemo(() => createQueryClient(), []);

  // El tema elegido se aplica antes de que haya nada que mirar.
  useEffect(() => {
    applyTheme(readTheme());
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider store={liveSession}>
        <RouterProvider router={router} context={{ session: liveSession }} />
      </SessionProvider>
      <QueryDevtools />
    </QueryClientProvider>
  );
}
